import { styled } from "styled-components";

export const ReportButton = styled.button`
	padding: 0.8rem;
	border: 1px solid #006770;
	color: #006770;
	border-radius: 1rem;
	width: ${(props) => (props.customwidth ? "10rem" : "7rem")};
	display: flex;
	gap: 0.5rem;
	justify-content: center;
	align-items: center;

    label{
        display: flex;
        gap: 1rem;
        cursor: pointer;
    }
`;

export const ReportTemplate = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.5rem;
`;
